import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';

import Header from './components/Header';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';

import HomePage from './pages/HomePage';
import BuyersPage from './pages/BuyersPage';
import LandlordsPage from './pages/LandlordsPage';
import SellersPage from './pages/SellersPage';
import TenantsPage from './pages/TenantsPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import ReportRepairPage from './pages/ReportRepairPage';
import ValuationPage from './pages/ValuationPage';
import NewsArticlePage from './pages/NewsArticlePage';
import PropertyPage from './pages/PropertyPage';
import PropertiesAdvancedPage from './pages/PropertiesAdvancedPage';
import PaymentsPage from './pages/PaymentsPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1e3a8a', // adjust to your aqua-blue
    },
    error: {
      main: '#af2e3d', // your brand red
    },
    background: {
      default: '#f7f8fa',
      paper: '#fff',
    },
  },
  typography: {
    fontFamily: 'Roboto, sans-serif',
  },
});

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      {/* resets browser default margins/padding */}
      <CssBaseline />

      <BrowserRouter>
        <Header />

        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/buyers" element={<BuyersPage />} />
          <Route path="/landlords" element={<LandlordsPage />} />
          <Route path="/sellers" element={<SellersPage />} />
          <Route path="/tenants" element={<TenantsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/repairs" element={<ReportRepairPage />} />
          <Route path="/payments" element={<PaymentsPage />} />
          <Route path="sellers/valuation" element={<ValuationPage />} />
          <Route path="/news/:slug" element={<NewsArticlePage />} />
          <Route path="/property/:slug" element={<PropertyPage />} />
          <Route path="/properties" element={<PropertiesAdvancedPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/privacy-policy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />

          {/* other routes */}
        </Routes>

        {/* will only render until accepted */}
        <CookieConsent />

        <Footer />
      </BrowserRouter>
    </ThemeProvider>
  );
}
